<template>
  <div class="petComp">
    <div class="navBox">
      <div
        class="navItem"
        :class="curNav === '0' ? 'active' : ''"
        @click="changeCurNav('0')"
      >
        <img class="navImg" src="../../../assets/img/mendian/zichan.png" />
        会员资产
      </div>
      <div
        class="navItem"
        :class="curNav === '1' ? 'active' : ''"
        @click="changeCurNav('1')"
      >
        <img class="navImg" src="../../../assets/img/mendian/chongwu.png" />
        宠物列表
      </div>
    </div>
    <div class="navContent">
      <div class="zichanBox" v-if="curNav === '0'">
        <div
          class="zichanItem"
          :class="curBusiness === '充值记录' ? 'active' : ''"
          @click="
            changeBusiness('充值记录');
            $store.commit('recharge/set_type', 'list');
          "
        >
          <span class="label">会员余额</span>
          <span class="value">
            <span class="num">
              {{ userInfo.card_info.frozen === true ? "(锁)" : "" }}
              {{ userInfo.card_info.user_yue || "--" }}</span
            >元
          </span>
        </div>
        <div v-if="userInfo.club_card"
          class="zichanItem"
          :class="curBusiness == '会员剩余天数' ? 'active' : ''"
          @click="changeBusiness('')"
        >
          <span class="label">会员剩余天数</span>
          <span class="value">
            <span class="num">{{ userInfo.club_card.surplus_day||'--' }}</span
            >天
          </span>
        </div>
        <div
          class="zichanItem"
          :class="curBusiness == '洗美卡' ? 'active' : ''"
          @click="changeBusiness('洗美卡')"
        >
          <span class="label">洗美卡</span>
          <span class="value">
            <span class="num">{{ cardCount.card_count }}</span
            >张
          </span>
        </div>
        <div
          class="zichanItem"
          :class="curBusiness == '礼品卡' ? 'active' : ''"
          @click="changeBusiness('礼品卡')"
        >
          <span class="label">礼品卡</span>
          <span class="value">
            <span class="num">{{ cardCount.gift_card_count }}</span
            >张
          </span>
        </div>
        <div
          class="zichanItem"
          :class="curBusiness == '优惠券' ? 'active' : ''"
          @click="changeBusiness('优惠券')"
        >
          <span class="label">优惠券</span>
          <span class="value">
            <span class="num">{{ cardCount.coupon_count }}</span
            >张
          </span>
        </div>
        <div
          class="zichanItem"
          :class="curBusiness == '积分' ? 'active' : ''"
          @click="changeBusiness('积分')"
        >
          <span class="label">积分</span>
          <span class="value">
            <span class="num">{{ userInfo.card_info.user_jifen || "--" }}</span
            >积分
          </span>
        </div>
        <div
          class="zichanItem"
          :class="curBusiness == '会员权益' ? 'active' : ''"
          @click="changeBusiness('会员权益')"
        >
          <span class="label">会员权益</span>
          <span class="value">
            <span class="num">{{ huiyuanquanyiNum }}</span
            >项
          </span>
        </div>
      </div>
      <div class="petsBox" v-if="curNav === '1'">
        <div class="nav">
          <div
            class="navItem"
            @click="changePet(item._id)"
            :class="curPetId === item._id ? 'active' : ''"
            v-for="(item, petIndex) in userInfo.pets_info"
            :key="petIndex"
          >
            <span
              style="position: absolute; top: -3px; right: 1px"
              v-if="item.lifeLong && item.lifeLong.status === 1"
            >
              <el-tooltip
                effect="dark"
                :content="item.lifeLong.remark"
                placement="top-start"
              >
                <img
                  style="height: 10px; cursor: pointer"
                  src="../../../assets/img/zhong.png"
                />
              </el-tooltip>
            </span>
            <div class="navText">{{ item.nick_name }}</div>
            <div class="navType" v-if="item.category_info">
              {{ item.category_info.name }}
            </div>
          </div>
        </div>
        <div class="panel" v-if="!$public.isNull(curPetId)">
          <div class="msg">
            {{ curPetInfo.apply_type ? curPetInfo.apply_type.title : "--" }}
            <div class="divider"></div>
            {{ curPetInfo.pet_sex ? curPetInfo.pet_sex : "--" }}
            <div class="divider"></div>
            {{ curPetInfo.pet_color ? curPetInfo.pet_color : "--" }}
            <div class="divider"></div>
            <span v-if="curPetInfo.bron_date">
              {{ curPetInfo.petAgeArr[0]+"岁"+curPetInfo.petAgeArr[1]+"月" }}
            </span>
            <span v-else>--</span>
            <div class="divider"></div>
            {{ curPetInfo.weight ? curPetInfo.weight : "--" }}kg
            <div class="divider"></div>
            <span style="color: #ffae11">
              {{ curPetInfo.sterilization === 0 ? "未绝育" : "已绝育" }}
            </span>
          </div>
          <div class="msg" v-if="!$public.isNull(curPetInfo.character)">
            <span style="color: #18a44c">{{ curPetInfo.character }}</span>
          </div>
          <div class="item">
            <div>
              出生日期：
              {{ curPetInfo.bron_date ? curPetInfo.bron_date : "--" }}
              <span
                v-if="curPetInfo.status && curPetInfo.status.value === '4'"
                style="color: red; font-weight: bold"
                >(已亡故)</span
              >
              <span
                v-if="curPetInfo.status && curPetInfo.status.value === '3'"
                style="color: red; font-weight: bold"
                >(已丢失)</span
              >
            </div>
            <div>犬证号码：{{ curPetInfo.pet_certificate_no || "--" }}</div>
            <!-- 犬证号码 -->
            <div>花生编码：{{ curPetInfo.inside_no || "--" }}</div>
            <!-- 脖圈号 -->
            <div>
              宠物芯片：{{ curPetInfo.eprom_no ? curPetInfo.eprom_no : "--" }}
            </div>
            <!-- 芯片标号 -->
            <div
              style="width: 154px; word-break: break-all; position: relative"
            >
              用具编号：{{ curPetInfo.tool_num || "--" }}
              <span class="edit" @click="openDrawer('修改')">修改</span>
              <!-- <span style="float: right;color: #1890FF;cursor: pointer;font-size: 14px;" @click="openDrawer('新增')">新增</span> -->
            </div>
          </div>
          
          <div class="entrance">
            <div
              class="entranceItem"
              :class="curBusiness === '病例记录' ? 'active' : ''"
              @click="changeBusiness('病例记录')"
            >
              <img
                class="entranceImg"
                v-if="curBusiness === '病例记录'"
                src="../../../assets/img/mendian/bingli_1.png"
              />
              <img
                class="entranceImg"
                v-else
                src="../../../assets/img/mendian/bingli.png"
              />
              <div class="entranceText" v-if="curBusiness === '病例记录'">
                病例记录
              </div>
              <div class="entranceText" v-else>病例记录</div>
            </div>
            <div
              class="entranceItem"
              :class="curBusiness === '免疫记录' ? 'active' : ''"
              @click="
                changeBusiness('免疫记录');
                $store.commit('ymqc/set_type', 'list');
              "
            >
              <img
                class="entranceImg"
                v-if="curBusiness === '免疫记录'"
                src="../../../assets/img/mendian/mianyi_1.png"
              />
              <img
                class="entranceImg"
                v-else
                src="../../../assets/img/mendian/mianyi.png"
              />
              <div class="entranceText" v-if="curBusiness === '免疫记录'">
                免疫记录
              </div>
              <div class="entranceText" v-else>免疫记录</div>
            </div>
            <div
              class="entranceItem"
              :class="curBusiness === '住院记录' ? 'active' : ''"
              @click="changeBusiness('住院记录')"
            >
              <img
                class="entranceImg"
                v-if="curBusiness === '住院记录'"
                src="../../../assets/img/mendian/zhuyuan_1.png"
              />
              <img
                class="entranceImg"
                v-else
                src="../../../assets/img/mendian/zhuyuan.png"
              />
              <div class="entranceText" v-if="curBusiness === '住院记录'">
                住院记录
              </div>
              <div class="entranceText" v-else>住院记录</div>
            </div>
            <div
              class="entranceItem"
              :class="curBusiness === '消费记录' ? 'active' : ''"
              @click="changeBusiness('消费记录')"
            >
              <img
                class="entranceImg"
                v-if="curBusiness === '消费记录'"
                src="../../../assets/img/mendian/xiaofei_1.png"
              />
              <img
                class="entranceImg"
                v-else
                src="../../../assets/img/mendian/xiaofei.png"
              />
              <div class="entranceText" v-if="curBusiness === '消费记录'">
                消费记录
              </div>
              <div class="entranceText" v-else>消费记录</div>
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            padding: 200px 0;
            text-align: center;
            width: 100%;
            background-color: #fff;
          "
        >
          暂无宠物信息
        </div>
      </div>
    </div>
    <drawerAddEditUserInfo
      v-if="drawerAddEditUserInfo_state"
      :dialog_type="drawerType"
      :userInfo="userInfo"
      :petInfo="curPetInfo"
      @submit="submit_drawerAddEditUserInfo"
    ></drawerAddEditUserInfo>
  </div>
</template>
<script>
import drawerAddEditUserInfo from "../../../components/drawer/drawer_addEditPetInfo.vue";
export default {
  components: { drawerAddEditUserInfo },
  data() {
    return {
      drawerAddEditUserInfo_state: false,
      drawerType: "",
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    curBusiness() {
      return this.$store.state.mendian.curBusiness;
    },
    cardCount() {
      return this.$store.state.mendian.cardCount;
    },
    huiyuanquanyiNum() {
      return this.$store.state.mendian.huiyuanquanyiNum;
    },
    curNav() {
      return this.$store.state.mendian.curNavPanelPet;
    },
  },
  mounted() {
console.log(this.$store.state.mendian.userInfo,this.$store.state.mendian.curBusiness,'this.$store.state.mendian.userInfo');

  },
  methods: {
    // 切换 资产和宠物列表
    changeCurNav(str) {
      this.$store.commit("mendian/set_curNavPanelPet", str);
    },
    // 跳转
    changeBusiness(str) {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
        return;
      }
      if (this.userInfo._id === "sankeId") {
        this.$message({
          message: "散客不可以使用此功能",
          type: "error",
        });
        return;
      }
      // if(str==='积分'){
      // 	this.$store.commit('mendian/set_curBusiness','ing')
      // 	this.$store.commit('ing/set_imgType','coding')
      // 	this.$store.commit('ing/set_text','正在开发中...')
      // 	return ;
      // }
      this.$store.commit("mendian/set_curBusiness", str);
    },
    // 切换宠物
    changePet(id) {
      this.$store.commit("mendian/set_curPetId", id);
    },
    // 新增 修改宠物
    openDrawer(str) {
      if (this.userInfo._id.length > 10) {
        if (str === "修改") {
          this.drawerType = "editPet";
          this.drawerAddEditUserInfo_state = true;
        } else if (str === "新增") {
          this.drawerType = "addPet";
          this.drawerAddEditUserInfo_state = true;
        }
      } else {
        this.$message({
          message: "请选择会员",
          type: "error",
        });
        return;
      }
    },
    submit_drawerAddEditUserInfo(b) {
      this.drawerAddEditUserInfo_state = false;
      if (b === true) {
        this.$http
          .get(process.env.VUE_APP_Url_member+"/api/middleware/Member/Single", { id: this.userInfo._id })
          .then((res) => {
            if (res.code == 0) {
              this.$store.commit("mendian/set_userInfo", res.data);
            }
          });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.petComp {
  width: 252px;
  height: 100%;
  .navBox {
    display: flex;
    border-radius: 4px;
    background-color: #fff;
    height: 46px;
    margin-bottom: 12px;
    .navItem {
      width: 100%;
      text-align: center;
      border-radius: 4px;
      color: $fontColor;
      cursor: pointer;
      display: flex;
      line-height: 46px;
      font-size: 14px;
      &.active {
        background-color: $mainColor;
        color: #ffffff;
      }
      .navImg {
        width: 38px;
        height: 46px;
        padding: 0px 9px 0;
      }
    }
  }
  .navContent {
    .zichanBox {
      .zichanItem {
        border-radius: 4px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        line-height: 52px;
        padding: 0 12px;
        box-sizing: border-box;
        margin-bottom: 12px;
        cursor: pointer;
        &.active {
          background-color: #fcd8b9;
        }
        .label {
          color: $fontColor;
        }
        .value {
          text-align: right;
          .num {
            color: $mainColor;
            margin-right: 2px;
          }
        }
      }
    }
    .petsBox {
      display: flex;
      border-radius: 8px;
      overflow: hidden;
      .nav {
        background-color: #fff8f2;
        width: 56px;
        &::-webkit-scrollbar {
          width: 4px;
          // height: 4px;
        }
        .navItem {
          width: 56px;
          padding: 6px 4px;
          box-sizing: border-box;
          text-align: center;
          color: #2a2a2a;
          cursor: pointer;
          position: relative;
          .navText {
            font-size: 12px;
            line-height: 14px;
            padding-top: 5px;
            padding-bottom: 3px;
          }
          .navType {
            font-size: 12px;
          }
          &:hover {
            // background-color: #1890FF;
          }
          &.active {
            color: #fff;
            background-color: $mainColor;
          }
        }
      }
      .panel {
        padding: 4px;
        width: 196px;
        box-sizing: border-box;
        background-color: #fff;
        .msg {
          display: flex;
          font-size: 12px;
          color: $fontColor;
          box-sizing: border-box;
          padding-top: 6px;
          flex-wrap: wrap;
          line-height: 18px;
          .divider {
            width: 1px;
            height: 12px;
            background-color: $fontColor;
            margin: 3px 4px 0;
          }
        }
        .item {
          font-size: 12px;
          color: #666666;
          line-height: 28px;
          padding: 6px 0;
          .edit {
            float: right;
            color: $mainColor;
            cursor: pointer;
            font-size: 12px;
            margin-left: 10px;
            position: absolute;
            right: -32px;
            top: 0px;
          }
        }
      }
      .entrance {
        display: flex;
        justify-content: space-around;
        padding: 0 0px;
        flex-wrap: wrap;
        .entranceItem {
          display: flex;
          cursor: pointer;
          width: 85px;
          height: 32px;
          background-color: #fef7eb;
          border-radius: 4px;
          margin-top: 12px;
          &.active {
            background-color: $mainColor;
            .entranceText {
              font-size: 12px;
              color: #fff;
              line-height: 32px;
            }
          }
          .entranceImg {
            width: 24px;
            height: 24px;
            padding: 4px 3px;
          }
          .entranceText {
            font-size: 12px;
            color: $fontColor;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
